export default {
  generic_error: "Une erreur s'est produite",
  address_not_found:
    "Désolé, nous n'avons pas trouvé cette adresse. Veuillez réessayer en saisissant d'abord la rue dans le champ de recherche.",
  internal_error:
    "Un problème inattendu s'est produit avec votre commande, notre équipe technique s'en occupe déjà 🛠️.",
};
